module.exports = __webpack_public_path__ + "img/5.365ddc88.png";